export const dispatchCustomEvent = (eventName, eventData = {}) => {
    const customEvent = new CustomEvent(eventName, { detail: eventData });
    window.dispatchEvent(customEvent);
};
